// Each process.env.REACT_APP_* access is replaced at build time with the
// value from the one .env file for that build. Do not read process or
// process.env as an object: the browser has no process, and that throws
// before the app can render.
const redirectUrl = '/dashboard';

export default {
  redirectUrl,
  gql_uri: process.env.REACT_APP_GQL_URI,
  vessel_uri: process.env.REACT_APP_VESSEL_ENDPOINT,
  master_uri: process.env.REACT_APP_MASTER_URI,
  apibaseurl: process.env.REACT_APP_API_BASE_URL,
  feedback: process.env.REACT_APP_API_BASE_URL,
  learning_endpoint: process.env.REACT_APP_LEARNING_ENDPOINT,
  domain_app: process.env.REACT_APP_DOMAIN_APP
};
